export default __webpack_public_path__ + "f3c5fab366b84dc0cd5d008d07b1857a.png";